// ─── Complimentary Bill Modal — shown when "Complimentary" is selected as payment ─
// Usage: <ComplimentaryModal amount={total} guestName={name} onClose={fn} onSubmit={fn} notify={fn} />
import React, { useState } from 'react';
import * as api from '../api/client';
import { inputStyle, btnPrimary, btnSm } from './UI';

const COMP_CATEGORIES = [
  { v:'vip_guest',  label:'VIP Guest' },
  { v:'complaint',  label:'Complaint Resolution' },
  { v:'staff_meal', label:'Staff Meal' },
  { v:'marketing',  label:'Marketing / Promotion' },
  { v:'error',      label:'Billing Error' },
  { v:'other',      label:'Other' },
];

export default function ComplimentaryModal({ amount, guestName='', billId=null, onClose, onSubmitted, notify }) {
  const [form, setForm] = useState({
    guest_name: guestName,
    category: 'other',
    reason: '',
  });
  const [loading, setLoading] = useState(false);

  const submit = async () => {
    if (!form.guest_name.trim()) { notify('Enter guest name', 'error'); return; }
    if (!form.reason.trim())     { notify('Provide a reason for the complimentary', 'error'); return; }
    setLoading(true);
    try {
      await api.createComplimentaryBill({
        guest_name: form.guest_name,
        category:   form.category,
        reason:     form.reason,
        amount:     parseFloat(amount) || 0,
        bill:       billId || null,
      });
      notify('✅ Complimentary request submitted — awaiting manager approval');
      onSubmitted && onSubmitted();
      onClose();
    } catch(e) {
      notify(e.response?.data?.error || 'Failed to submit complimentary request', 'error');
    } finally { setLoading(false); }
  };

  const lbl = { fontSize:10, letterSpacing:1, color:'var(--textMuted)', textTransform:'uppercase', marginBottom:5, display:'block', fontWeight:600 };

  return (
    <div style={{ position:'fixed', inset:0, background:'var(--bgModal)', zIndex:1100, display:'flex', alignItems:'center', justifyContent:'center', padding:20 }}>
      <div style={{ background:'var(--bgCard)', border:'1px solid #333', borderRadius:8, padding:24, width:'100%', maxWidth:480, boxShadow:'0 20px 60px rgba(0,0,0,0.8)' }}>
        {/* Header */}
        <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:16 }}>
          <div>
            <div style={{ fontSize:16, fontWeight:700, color:'#c8a96e' }}>🎁 Complimentary Bill</div>
            <div style={{ fontSize:12, color:'var(--textMuted)', marginTop:3 }}>Amount: <strong style={{ color:'#c8a96e' }}>KES {parseFloat(amount||0).toLocaleString()}</strong></div>
          </div>
          <button onClick={onClose} style={{ background:'none', border:'none', color:'#666', fontSize:20, cursor:'pointer' }}>✕</button>
        </div>

        {/* Info banner */}
        <div style={{ background:'rgba(200,169,110,0.08)', border:'1px solid rgba(200,169,110,0.25)', borderRadius:6, padding:'10px 14px', marginBottom:16, fontSize:12, color:'#c8a96e' }}>
          ⚠️ This bill will be waived and submitted for <strong>manager approval</strong>. Once approved, it is automatically recorded as a hotel expense.
        </div>

        <div style={{ display:'grid', gap:12 }}>
          <div>
            <label style={lbl}>Guest Name *</label>
            <input style={inputStyle} value={form.guest_name} onChange={e=>setForm({...form,guest_name:e.target.value})} placeholder="Full name" />
          </div>
          <div>
            <label style={lbl}>Category *</label>
            <select style={inputStyle} value={form.category} onChange={e=>setForm({...form,category:e.target.value})}>
              {COMP_CATEGORIES.map(c=><option key={c.v} value={c.v}>{c.label}</option>)}
            </select>
          </div>
          <div>
            <label style={lbl}>Reason / Justification *</label>
            <textarea style={{ ...inputStyle, height:80, resize:'none' }}
              value={form.reason} onChange={e=>setForm({...form,reason:e.target.value})}
              placeholder="Explain why this bill is being comped (VIP guest, complaint resolution, service failure, etc.)" />
          </div>
        </div>

        <div style={{ display:'flex', gap:8, marginTop:16 }}>
          <button style={{ ...btnSm, flex:1 }} onClick={onClose}>Cancel</button>
          <button style={{ ...btnPrimary, flex:2, background:'#c8a96e', color:'#111', opacity:loading?0.6:1 }} disabled={loading} onClick={submit}>
            {loading ? 'Submitting…' : '📤 Submit for Manager Approval'}
          </button>
        </div>
      </div>
    </div>
  );
}
